/*
 * 配列の値検索 + 取得関連の処理
 */
/**
 * 定数candidatesからのvalueでの検索とlabelの取得
 * @param list 検索対象の配列
 * @param value 検索対象の値
 * @returns {string}
 */
export const findCandidatesLabel = (list, value) => {
    var _a;
    const intValue = typeof value === 'string' ? parseInt(value, 10) : value;
    return ((_a = list.find((item) => item.value === intValue)) === null || _a === void 0 ? void 0 : _a.label) || '';
};
